import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccordionModule } from 'primeng/accordion';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { DropdownModule } from 'primeng/dropdown';
import { ImageModule } from 'primeng/image';
import { ProgressBarModule } from 'primeng/progressbar';
import { RatingModule } from 'primeng/rating';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TooltipModule } from 'primeng/tooltip';
import { Currency, getCurrencyDescription } from '../../../models/enums/UserRole';
import { InstituteCommonDetailsV2Response } from '../../../models/institute/instituteCommonDetailsV2Response';
import { InstituteUnderGraduateDetailsV2Response } from '../../../models/institute/instituteUnderGraduateDetailsV2Response';
import { InstituteMasterDetailsV2Response } from '../../../models/institute/InstituteMasterDetailsV2Response';
import { InstituteService } from '../../../services/institute/institute.service';
import { InstituteGraduateSchoolsWithInV2Response } from '../../../models/institute/instituteGraduateSchoolsWithInV2Response';
import { InstituteTotalEnrollmentsV2Response } from '../../../models/institute/instituteTotalEnrollmentsV2Response';
import { InstituteDetailAlumniComponent } from '../institute-detail-alumni/institute-detail-alumni.component';


interface InstituteRaceEthnicityData {
  white: string | null;
  black: string | null;
  hispanic: string | null;
  asian: string | null;
  americanIndianOrAlaskaNative: string | null;
  nativeHawaiianOrOtherPacificIslander: string | null;
  twoOrMoreRaces: string | null;
  raceOrEthnicityUnknown: string | null;
  blackOrAfricanAmerican: string | null // For Master Details
  hispanicOrLatino: string | null // For Master Details

}

@Component({
  selector: 'app-institute-detail-us',
  standalone: true,
  imports: [CommonModule, FormsModule, CheckboxModule, ImageModule, BreadcrumbModule,
    RouterModule, ChipModule, TooltipModule, AccordionModule, DropdownModule, ProgressBarModule,
    RatingModule, ScrollPanelModule, ChartModule, InstituteDetailAlumniComponent],
  templateUrl: './institute-detail-us.component.html',
  styleUrl: './institute-detail-us.component.scss'
})
export class InstituteDetailUsComponent implements OnChanges {

  ngOnChanges(): void {
    console.log('netPriceCalculator:', this.institute?.netPriceCalculator);
    this.prepareChartData();
    this.listGraduateSchools();
    this.listMajors();
    if (this.isUGDetails(this.instituteUGMDetails)) {
      this.popularEmployers = this.instituteUGMDetails.popularEmployers;
      this.scholarships = this.instituteUGMDetails.findScholarships || [];
    }

  }
  private instituteService = inject(InstituteService);
  @Input() instituteUGMDetails!: InstituteUnderGraduateDetailsV2Response | InstituteMasterDetailsV2Response;
  instituteBachelorMajors: InstituteTotalEnrollmentsV2Response[] = [];
  instituteGraduateMajors: InstituteTotalEnrollmentsV2Response[] = [];
  instituteDoctoralMajors: InstituteTotalEnrollmentsV2Response[] = [];
  @Input() institute: InstituteCommonDetailsV2Response | undefined;
  @Input() selectedProgramType: string | undefined;
  popularEmployers?: string | null;
  graduateSchoolsWithin: InstituteGraduateSchoolsWithInV2Response[] = [];
  raceData: InstituteRaceEthnicityData | null = null;
  pieData: any;
  pieOptions: any;
  @Output() requestDisplayCourses = new EventEmitter<void>();
  accordionHeaderText: string = 'More';
  scholarships: string[] = [];
  showAllGraduateSchoolsWithin = false;
  showAllScholarships = false;
  showAllUGMajors = false;
  showAllPGMajors = false;
  showAllDoctoralMajors = false;

  get visibleScholarships() {
    return this.showAllScholarships ? this.scholarships : this.scholarships.slice(0, 3);
  }
  toggleScholarshipsView() {
    this.showAllScholarships = !this.showAllScholarships;
  }
  get visibleGraduateSchoolsWithin() {
    return this.showAllGraduateSchoolsWithin ? this.graduateSchoolsWithin : this.graduateSchoolsWithin.slice(0, 3);
  }
  toggleGraduateSchoolsView() {
    this.showAllGraduateSchoolsWithin = !this.showAllGraduateSchoolsWithin;
  }

  get visibleUGMajors() {
    return this.getVisibleMajors(this.instituteBachelorMajors, this.showAllUGMajors);
  }
  get visiblePGMajors() {
    return this.getVisibleMajors(this.instituteGraduateMajors, this.showAllPGMajors);
  }
  get visibleDoctoralMajors() {
    return this.getVisibleMajors(this.instituteDoctoralMajors, this.showAllDoctoralMajors);
  }

  getVisibleMajors(courses: any[], showAll: boolean): any[] {
    return showAll ? courses : courses.slice(0, 3);
  }
  getExternalUrl(url: string | null | undefined): string {
  if (!url) return '';
  const trimmed = url.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

  toggleMajorsView(key: 'UG' | 'PG' | 'Doctoral') {
    const prop = `showAll${key}Majors` as 'showAllUGMajors' | 'showAllPGMajors' | 'showAllDoctoralMajors';
    this[prop] = !this[prop];
  }

  triggerDisplayCourses() {
    this.requestDisplayCourses.emit();
  }

  listGraduateSchools() {
    this.instituteService.listInstituteGraduateSchoolsWithIn(this.institute!.id).subscribe({
      next: (response) => {
        this.graduateSchoolsWithin = response.result;
      }
    })
  }
  listMajors() {
    this.instituteService.listInstituteTotalEnrollments({
      instituteId: this.institute!.id,
      levelOfCrediential: 'Bachelor'
    }).subscribe({
      next: (response) => {
        this.instituteBachelorMajors = response.result;
      }
    });
    this.instituteService.listInstituteTotalEnrollments({
      instituteId: this.institute!.id,
      levelOfCrediential: 'Master'
    }).subscribe({
      next: (response) => {
        this.instituteGraduateMajors = response.result;
      }
    });
    this.instituteService.listInstituteTotalEnrollments({
      instituteId: this.institute!.id,
      levelOfCrediential: 'Doctoral'
    }).subscribe({
      next: (response) => {
        this.instituteDoctoralMajors = response.result;
      }
    })
  }
  getAmount(currency: Currency, amount: string | number): string {
    const amountNum = Number(amount);
    const formattedAmount = amountNum.toLocaleString('en-US'); // or 'en-US' based on formatting needs
    return `${getCurrencyDescription(currency)} ${formattedAmount}`;
  }

  stringToPercent(amount: string | number): Number {
    const amountNum = Number(amount);
    return Number((amountNum * 100).toFixed(2));
  }

  isUGDetails(details: InstituteUnderGraduateDetailsV2Response | InstituteMasterDetailsV2Response): details is InstituteUnderGraduateDetailsV2Response {
    return (
      details != null &&
      'totalApplicants' in details
    );
  }

  // ✅ Type guard for Masters
  isMastersDetails(details: InstituteUnderGraduateDetailsV2Response | InstituteMasterDetailsV2Response): details is InstituteMasterDetailsV2Response {
    return (
      details != null &&
      'graduateStudentsEnrolled' in details
    );
  }

  parsePercentage(percentageString: string | null): number {
    if (percentageString) {
      return parseFloat(percentageString.replace('%', ''));
    }
    return 0; // Return 0 if percentageString is null or undefined
  }

  prepareChartData() {
    if (this.isUGDetails(this.instituteUGMDetails)) {
      this.raceData = {
        white: this.instituteUGMDetails?.white ?? null,
        black: this.instituteUGMDetails?.black ?? null,
        hispanic: this.instituteUGMDetails?.hispanic ?? null,
        asian: this.instituteUGMDetails?.asian ?? null,
        americanIndianOrAlaskaNative: this.instituteUGMDetails?.americanIndianOrAlaskaNative ?? null,
        nativeHawaiianOrOtherPacificIslander: this.instituteUGMDetails?.nativeHawaiianOrOtherPacificIslander ?? null,
        twoOrMoreRaces: this.instituteUGMDetails?.twoOrMoreRaces ?? null,
        raceOrEthnicityUnknown: this.instituteUGMDetails?.raceOrEthnicityUnknown ?? null,
        blackOrAfricanAmerican: null, // Not applicable for UG details
        hispanicOrLatino: null // Not applicable for UG details
      };
    } else if (this.isMastersDetails(this.instituteUGMDetails)) {
      this.raceData = {
        white: this.instituteUGMDetails?.white ?? null,
        black: null,
        hispanic: null,
        asian: this.instituteUGMDetails?.asian ?? null,
        americanIndianOrAlaskaNative: this.instituteUGMDetails?.americanIndianOrAlaskaNative ?? null,
        nativeHawaiianOrOtherPacificIslander: this.instituteUGMDetails?.nativeHawaiianOrOtherPacificIslander ?? null,
        twoOrMoreRaces: this.instituteUGMDetails?.twoOrMoreRaces ?? null,
        raceOrEthnicityUnknown: this.instituteUGMDetails?.raceOrEthnicityUnknown ?? null,
        blackOrAfricanAmerican: this.instituteUGMDetails?.blackOrAfricanAmerican ?? null,
        hispanicOrLatino: this.instituteUGMDetails?.hispanicOrLatino ?? null
      };
    }
if (this.raceData) {
  const raw = [
    { label: 'White', value: this.parsePercentage(this.raceData.white), color: '#FF6384' },
    { label: 'Black', value: this.parsePercentage(this.raceData.black), color: '#36A2EB' },
    { label: 'Hispanic', value: this.parsePercentage(this.raceData.hispanic), color: '#FFCE56' },
    { label: 'Asian', value: this.parsePercentage(this.raceData.asian), color: '#4BC0C0' },
    { label: 'American Indian/Alaska Native', value: this.parsePercentage(this.raceData.americanIndianOrAlaskaNative), color: '#9966FF' },
    { label: 'Native Hawaiian/Pacific Islander', value: this.parsePercentage(this.raceData.nativeHawaiianOrOtherPacificIslander), color: '#FF9F40' },
    { label: 'Two or More Races', value: this.parsePercentage(this.raceData.twoOrMoreRaces), color: '#808080' },
    { label: 'Unknown', value: this.parsePercentage(this.raceData.raceOrEthnicityUnknown), color: '#008000' },
    { label: 'Black or African American', value: this.parsePercentage(this.raceData.blackOrAfricanAmerican), color: '#FFA07A' },
    { label: 'Hispanic/Latino', value: this.parsePercentage(this.raceData.hispanicOrLatino), color: '#20B2AA' },
  ];

  // If values are fractions (sum ≈ 1), convert to real percentages
  const total = raw.reduce((s, e) => s + e.value, 0);
  const scale = total > 0 && total <= 1.5 ? 100 : 1;
  const entries = raw
    .map(e => ({ ...e, value: e.value * scale }))
    .filter(e => e.value > 0);

  this.pieData = {
    labels: entries.map(e => e.label),
    datasets: [{
      data: entries.map(e => e.value),
      backgroundColor: entries.map(e => e.color),
      hoverBackgroundColor: entries.map(e => e.color),
    }],
  };

  this.pieOptions = {
    plugins: {
      legend: { display: false },   // legend hidden
      tooltip: {
        callbacks: {
          label: (context: any) => `${context.label}: ${Number(context.parsed).toFixed(1)}%`,
        },
      },
    },
  };
}
    // if (this.raceData) {
    //   this.pieData = {
    //     labels: [
    //       'White',
    //       'Black',
    //       'Hispanic',
    //       'Asian',
    //       'American Indian/Alaska Native',
    //       'Native Hawaiian/Pacific Islander',
    //       'Two or More Races',
    //       'Unknown',
    //       'Black or African American', //For Master Details
    //       'Hispanic/Latino' //For Master Details
    //     ],
    //     datasets: [
    //       {
    //         data: [
    //           this.parsePercentage(this.raceData.white),
    //           this.parsePercentage(this.raceData.black),
    //           this.parsePercentage(this.raceData.hispanic),
    //           this.parsePercentage(this.raceData.asian),
    //           this.parsePercentage(this.raceData.americanIndianOrAlaskaNative),
    //           this.parsePercentage(this.raceData.nativeHawaiianOrOtherPacificIslander),
    //           this.parsePercentage(this.raceData.twoOrMoreRaces),
    //           this.parsePercentage(this.raceData.raceOrEthnicityUnknown),
    //           this.parsePercentage(this.raceData.blackOrAfricanAmerican),
    //           this.parsePercentage(this.raceData.hispanicOrLatino),
    //         ],
    //         backgroundColor: [
    //           '#FF6384',
    //           '#36A2EB',
    //           '#FFCE56',
    //           '#4BC0C0',
    //           '#9966FF',
    //           '#FF9F40',
    //           '#808080',
    //           '#008000',
    //           '#FFA07A',
    //           '#20B2AA'
    //         ],
    //         hoverBackgroundColor: [
    //           '#FF6384',
    //           '#36A2EB',
    //           '#FFCE56',
    //           '#4BC0C0',
    //           '#9966FF',
    //           '#FF9F40',
    //           '#808080',
    //           '#008000',
    //           '#FFA07A',
    //           '#20B2AA'
    //         ],
    //       },
    //     ],
    //   };

    //   this.pieOptions = {
    //     plugins: {
    //       legend: {
    //         display: false,
    //         position: 'right',
    //         labels: {
    //           color: '#495057',
    //         },
    //       },
    //       tooltip: {
    //         callbacks: {
    //           label: (context: any) => {
    //             const label = context.label || '';
    //             const data = context.dataset.data;
    //             const value = context.parsed;
    //             const total = data.reduce((sum: number, val: any) => sum + val, 0);
    //             const percentage = total ? ((value / total) * 100).toFixed(2) : 0;
    //             return `${label}: (${value}%)`;
    //           },
    //         },
    //       },
    //     },
    //   };

    // }
  }
  formatPercent(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return 'N/A';
  const num = Number(value);
  if (isNaN(num)) return 'N/A';
  return `${Number((num * 100).toFixed(2))}%`;
}
getPercentOf(part: number | string | null | undefined, total: number | string | null | undefined): string {
  const p = Number(part);
  const t = Number(total);
  if (!t || isNaN(p) || isNaN(t)) return 'N/A';
  return `${Number(((p / t) * 100).toFixed(2))}%`;
}
}
